import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const antiBullyingDeviceManager = {
	/**
	 *
	 * @param schoolId
	 * @returns {Promise<APIResponse<number[]>>}
	 */
	getDeviceManagersBySchoolId(schoolId) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/anti-bullying/v1/device-manager/list`,
			headers: config.headers,
			params: { schoolId }
		});
	},

	/**
	 *
	 * @param schoolId
	 * @returns {Promise<APIResponse<number[]>>}
	 */
	getDeviceManagerBySchoolId(schoolId) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/anti-bullying/v1/device-manager`,
			headers: config.headers,
			params: { schoolId }
		});
	},

	/**
	 * @typedef {Object} AddDelStaffBo
	 * @property {number} schoolId
	 * @property {number[]} deviceManagerIds
	 */

	/**
	 *
	 * @param {AddDelStaffBo} data
	 * @returns {Promise<APIResponse>}
	 */
	removeDeviceManager(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/anti-bullying/v1/device-manager/remove`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},

	/**
	 *
	 * @param {AddDelStaffBo} data
	 * @returns {Promise<APIResponse>}
	 */
	addDeviceManager(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/anti-bullying/v1/device-manager/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};

export default antiBullyingDeviceManager;
